<template>
 <header>
  <div id="header_downside_top" v-if="showDownside">
   <ul class="hddw_nav_top">
    <li id="title_logo_top">
      <img :src="getImage('component/common/header/daros_logo_black.svg')" width="160px" height="auto"/>
      <span>Domans Automatic Realization & Operation System</span>
    </li>
    <li class="account_top">
     <a @click="onClickCorpConfig">
       <img :src="getImage('pages/planning/ic_corp_black.svg')" alt="company"/>
       <span>{{ userInfo.corpName }}</span>
       <img class="arrow" :src="getImage('component/common/header/ic_arrow_right_black.svg')" alt="user"/>
     </a>
    </li>
    <li class="account_top">
     <a href="#" @click.prevent>
       <img :src="getImage('pages/planning/ic_user_black.svg')" alt="user"/>
       <span>{{ userInfo.userName }}</span>
       <img class="arrow" :src="getImage('component/common/header/ic_arrow_right_black.svg')" alt="user"/>
     </a>
    </li>
    <li class="logout_top">
      <a href="#" @click.prevent="logout">
        <img :src="getImage('component/common/header/ic_logout.svg')"/>
        <span>Logout</span>
      </a>
    </li>
   </ul>
  </div>
 </header>
</template>
<script>
import axios from 'axios'
import {API_URL, STORAGE_KEY} from '../../constants/App'
import {USER_TYPE} from '../../constants/Type'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'

export default {
  name: 'Header',
  props: {
    showUpside: {
      type: Boolean,
      default: true
    },
    showDownside: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    userInfo: function () {
      return App.getUserInfo()
    }
  },
  methods: {
    logout: function (event) {
      axios.post(API_URL.LOGOUT, {}
      ).then(response => {
        App.removeLocalStorage(STORAGE_KEY.USER_INFO)
        this.$router.push('/login')
      }).catch(error => {
        Api.handleError(error)
      })
    },
    onClickCorpConfig: function () {
      const user = App.getLocalStorage(STORAGE_KEY.USER_INFO)
      if (user.userType === USER_TYPE.DOMANS_ADMIN.code || user.userType === USER_TYPE.ADMIN.code || user.userType === USER_TYPE.SYSTEM_ADMIN.code) {
        let modalData = {
          routeOrderList: () => { this.$router.push({name: 'Order'}) }
        }
        App.showCorpConfigModal(modalData)
      }
    },
    getImage: function (image) {
      return App.getDarosResource(image)
    }
  }
}
</script>
<style src="../../css/top/top.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.hddw_nav li:first-child {
  margin-right:auto;
  font-weight: bold;
  padding-left: 47px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/common/TopHeader.vue